import dayjs from 'dayjs';

/**
 * Computes the date corresponding to the nth occurrence of the same day of the week in the next month,
 * maintaining the week number and day of the week relative to the given initial date.
 */
export function computeNextMonthNthDay(
  initialDate: string,
  previousDate: string
) {
  const initialDateObj = dayjs(initialDate);
  const initialDayOfWeek = initialDateObj.day();
  const initialDayInMonth = initialDateObj.date();
  const initialWeekNumber = Math.ceil(initialDayInMonth / 7);

  const nextMonthFromPreviousDate = dayjs(previousDate)
    .add(1, 'month')
    .startOf('month');

  const nextMonthDayFirstOccurrence =
    nextMonthFromPreviousDate.day() <= initialDayOfWeek
      ? nextMonthFromPreviousDate.day(initialDayOfWeek)
      : nextMonthFromPreviousDate.add(1, 'week').day(initialDayOfWeek);

  return nextMonthDayFirstOccurrence.add(initialWeekNumber - 1, 'weeks');
}
